import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RequiredInput} from '../../../decorators/common.decorators';
import {StringSearch} from '../../../services/common-datatypes';

@Component({
    selector: 'app-text-search-simple',
    templateUrl: './text-search-simple.component.html',
    styleUrls: ['./text-search-simple.component.scss']
})
export class TextSearchSimpleComponent {

    @Input() @RequiredInput translationPrefix!: string;

    @Input() @RequiredInput stringSearch: StringSearch | undefined;
    @Output() stringSearchChange = new EventEmitter<StringSearch>();

    constructor() {
    }

    clearSearch() {
        if (this.stringSearch) this.stringSearch.reset();
        this.dataChange();
    }

    dataChange() {
        if (this.stringSearch) this.stringSearchChange.emit(this.stringSearch);
    }


}
